import { render } from "./ModalFreeProduct.vue?vue&type=template&id=52355d7d&scoped=true&ts=true"
import script from "./ModalFreeProduct.vue?vue&type=script&lang=ts"
export * from "./ModalFreeProduct.vue?vue&type=script&lang=ts"

import "./ModalFreeProduct.vue?vue&type=style&index=0&id=52355d7d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52355d7d"]])

export default __exports__